module.exports = __webpack_public_path__ + "img/infoicon.86d64249.svg";